import React from 'react'

// Components
import Error from '../global/error'

// Libs
import classnames from 'classnames'

const Input = ({ value, onChange, onBlur, classes, name, type, placeholder, errors }) => {
    let _classes = classnames(classes, { "error": errors && errors.length })
    return (
        <>
            <input
                className={_classes}
                type={type}
                name={name}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
            />
            {errors && (
                errors.map((e, i) => <Error key={i} index={i} message={e} />))}
        </>
    )
}

export default Input